var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(2 0.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1136",
    "data-name": "Rectangle 1136",
    width: 32,
    height: 32,
    transform: "translate(-2 -0.417)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M33.379,5.809A6.518,6.518,0,0,1,38.4,16.481a.4.4,0,0,0-.029.477L39.44,18.64l-2.713-.6a.42.42,0,0,0-.281.037,6.456,6.456,0,0,1-4.766.534,8.455,8.455,0,0,1,.065.855,7.262,7.262,0,0,0,1.637.191,7.356,7.356,0,0,0,3.312-.79l3.528.782a.32.32,0,0,0,.09.008.41.41,0,0,0,.346-.627l-1.434-2.265A7.33,7.33,0,0,0,33.392,4.99a7.238,7.238,0,0,0-7.312,6.9,7.864,7.864,0,0,1,.8.305A6.522,6.522,0,0,1,33.388,5.8Z",
    transform: "translate(-14.271 0)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M36,15.5h6.517v1.222H36Z",
    transform: "translate(-20.151 -6.229)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    d: "M36,21.5h6.517v1.222H36Z",
    transform: "translate(-20.151 -9.785)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    d: "M40,27.5h4.888v1.222H40Z",
    transform: "translate(-22.521 -13.341)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    d: "M5.886,36.8a7.34,7.34,0,1,0-2.2-1.8L2,37.664Zm3.446-2.2a.815.815,0,1,1,.815-.815A.817.817,0,0,1,9.332,34.609Zm0-8.554a2.24,2.24,0,0,1,.611,4.4v1.511H8.721V29.925a.61.61,0,0,1,.611-.611A1.018,1.018,0,1,0,8.314,28.3H7.092A2.244,2.244,0,0,1,9.332,26.055Z",
    transform: "translate(0 -10.674)",
    fill: "#09c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.924be77b22e498daa3a8a1658bdbfe03.svg";
export { ForwardRef as ReactComponent };